export default "__VITE_ASSET__D6Vv6fP0__"